var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCirclePassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 18.3334C14.5832 18.3334 18.3332 14.5834 18.3332 10C18.3332 5.41669 14.5832 1.66669 9.99984 1.66669C5.4165 1.66669 1.6665 5.41669 1.6665 10C1.6665 14.5834 5.4165 18.3334 9.99984 18.3334ZM9.99984 9.25002C10.4141 9.25002 10.7498 9.58581 10.7498 10V14.1667C10.7498 14.5809 10.4141 14.9167 9.99984 14.9167C9.58562 14.9167 9.24984 14.5809 9.24984 14.1667V10C9.24984 9.58581 9.58562 9.25002 9.99984 9.25002ZM9.99536 5.66669C9.44308 5.66669 8.99536 6.1144 8.99536 6.66669C8.99536 7.21897 9.44308 7.66669 9.99536 7.66669H10.0028C10.5551 7.66669 11.0028 7.21897 11.0028 6.66669C11.0028 6.1144 10.5551 5.66669 10.0028 5.66669H9.99536Z",
    fill: "#FF7F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCirclePassword);
export default __webpack_public_path__ + "static/media/info-circle-password.e60f13569447688ef727d94e395d44b3.svg";
export { ForwardRef as ReactComponent };